module.exports = __webpack_public_path__ + "static/whitebunny-4e546b520ad87fedd61a306d3365a1e8.jpeg";